// extracted by mini-css-extract-plugin
export default {"circle-checkbox":"CircleCheckbox_circle-checkbox__t-qcX","icon-wrapper":"CircleCheckbox_icon-wrapper__jHQOi","disabled":"CircleCheckbox_disabled__jcSHa"};